import React from 'react';
import ExtrasLayout from '@/components/layout/ExtrasLayout';

const Legal: React.FC = () => {
  return (
    <ExtrasLayout title="Legal & Regulatory">
      <h4 className="extra-page__heading">No Offer or Solicitation</h4>
      <p>
        The information contained on this website is provided for informational purposes only and
        does not constitute an offer to sell, or a solicitation of an offer to buy, any security
        or investment product in any jurisdiction. Any such offer or solicitation may be made only
        pursuant to definitive offering documents, including a confidential private placement
        memorandum and related subscription materials, and only to persons who meet applicable
        eligibility requirements.
      </p>
      <h4 className="extra-page__heading">Forward-Looking Statements</h4>
      <p>
        Certain statements on this website may constitute “forward-looking statements” within the
        meaning of applicable securities laws. These statements reflect current views,
        assumptions, expectations, and beliefs regarding future events, market conditions, or
        performance, and are inherently subject to risks, uncertainties, and factors that may
        cause actual outcomes to differ materially from those expressed or implied.
      </p>
      <p>
        Forward-looking statements may include, but are not limited to, statements regarding
        investment strategy, market opportunity, sector trends, asset performance, cash flows, or
        future developments. Such statements are based on information available as of the date
        made and speak only as of that date.
      </p>
      <p>
        No representation or warranty is made that any forward-looking statement will be achieved
        or that actual results will not differ materially. Ephemera Partners, L.P. undertakes no
        obligation to update or revise any forward-looking statements as a result of new
        information, future events, or otherwise.
      </p>
      <h4 className="extra-page__heading">Private Offering; Securities Law Exemptions</h4>
      <p>
        Ephemera Partners, L.P. (the “Partnership”) is a private investment vehicle formed under
        the Delaware Revised Uniform Limited Partnership Act (6 Del. C. §17-101 et seq.).
      </p>
      <h4 className="extra-page__heading">Jurisdictional Restrictions</h4>
      <p>
        This website is not directed to, and may not be accessed or used by, any person in any
        jurisdiction where the publication or availability of the information contained herein
        would be contrary to applicable law or regulation. Persons accessing this website do so on
        their own initiative and are responsible for compliance with all applicable local laws and
        regulations.
      </p>
      <h4 className="extra-page__heading">No Investment Advice</h4>
      <p>
        Nothing contained on this website constitutes investment, legal, tax, or accounting
        advice, or a recommendation regarding any investment strategy or security. Prospective
        investors should consult their own advisers before making any investment decision.
      </p>
      <h4 className="extra-page__heading">Accuracy; No Reliance</h4>
      <p>
        While the information contained on this website is believed to be accurate as of the date
        presented, no representation or warranty, express or implied, is made as to its accuracy,
        completeness, or fairness. Information may be updated, amended, or withdrawn at any time
        without notice. No person should rely on the information contained herein for any purpose.
      </p>
      <h4 className="extra-page__heading">No Performance Information</h4>
      <p>
        This website does not contain performance data, targeted returns, or projections, and
        should not be interpreted as implying any level of investment performance or results.
      </p>
      <h4 className="extra-page__heading">Privacy</h4>
      <p>
        Any personal information submitted through this website will be handled in accordance with
        applicable data protection laws. Ephemera Partners does not sell or share personal
        information with third parties except as required by law or as necessary to operate this
        website.
      </p>
      <h4 className="extra-page__heading">Intellectual Property</h4>
      <p>
        All content on this website, including text, images, graphics, and design elements, is the
        property of Ephemera Partners, L.P. or its licensors and is protected by applicable
        intellectual property laws. No content may be reproduced, distributed, or transmitted
        without prior written consent.
      </p>
      <h4 className="extra-page__heading">Governing Law</h4>
      <p>
        This website and any disputes arising out of or relating to its use shall be governed by
        and construed in accordance with the laws of the State of Delaware, without regard to
        conflict-of-laws principles.
      </p>
    </ExtrasLayout>
  );
};

export default Legal;
